/* [BRAND] — lm-global.js · globale Funktionen ohne theme.liquid-Edit (geladen über sections/lm-global.liquid)
   1) Header-Icon-Labels  2) Back-to-top  3) Cart-Drawer/Cart-Page: Versandkosten-Balken + Preview-Thumbnails
   Preview-Thumbnails: Line-Item-Property "_preview_url" (gesetzt vom Konfigurator) ersetzt das Produktbild im Warenkorb. */
(function () {
  'use strict';
  var root = document.getElementById('lm-global');
  if (!root) return;
  var cfg = {
    threshold: Number(root.dataset.freeShipping || 0) * 100,
    labels: { search: root.dataset.labelSearch, account: root.dataset.labelAccount, cart: root.dataset.labelCart },
    iconLabels: root.dataset.iconLabels === 'true',
    toTop: root.dataset.backToTop === 'true',
    previews: root.dataset.cartPreviews === 'true',
    msgAway: root.dataset.msgAway || "You're {amount} away from free US shipping",
    msgDone: root.dataset.msgDone || 'Free US shipping unlocked',
    cartTrust: root.dataset.cartTrust || ''
  };

  /* ---------- 1) Header-Icons vereinheitlichen ----------
     Dawn liefert drei Icons in drei Sprachen: Lupe auf 18x19, Konto auf 18x19, Tasche auf 40x40,
     alle als Flaechen (fill). Nebeneinander wirken sie unterschiedlich schwer und unterschiedlich
     gross - egal wie man die Boxen skaliert. Deshalb werden sie hier durch drei eigene Strichicons
     auf demselben 24er-Raster ersetzt (gleiche Strichstaerke wie snippets/lm-icon.liquid).
     Das Original bleibt im DOM, nur versteckt: Dawn tauscht die Klassen icon-cart-empty/icon-cart
     beim Aktualisieren des Warenkorbs, das soll weiter funktionieren. */
  var HEADER_PATHS = {
    search: '<circle cx="10.8" cy="10.8" r="6.4"/><path d="m15.6 15.6 4.4 4.4"/>',
    account: '<circle cx="12" cy="8.2" r="3.5"/><path d="M5 20c.5-3.6 3.4-5.7 7-5.7s6.5 2.1 7 5.7"/>',
    cart: '<path d="M6.4 8.4h11.2l1 10.4a1.5 1.5 0 0 1-1.5 1.6H6.9a1.5 1.5 0 0 1-1.5-1.6l1-10.4Z"/><path d="M9.3 10.6V7.4a2.7 2.7 0 0 1 5.4 0v3.2"/>'
  };
  function lmSvg(key) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'lm-hicon lm-hicon--' + key);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.7');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.innerHTML = HEADER_PATHS[key];
    return svg;
  }
  function paintHeaderIcons() {
    [['.header__icon--search > span > .svg-wrapper:not(.header__icon-close)', 'search'],
     ['shopify-account > [slot]', 'account'],
     ['#cart-icon-bubble > .svg-wrapper', 'cart']].forEach(function (p) {
      document.querySelectorAll(p[0]).forEach(function (wrap) {
        if (wrap.querySelector('.lm-hicon')) return;
        var orig = wrap.querySelector('svg:not(.lm-hicon)');
        if (orig) orig.classList.add('lm-hicon-orig');
        wrap.appendChild(lmSvg(p[1]));
      });
    });
  }

  /* ---------- 1b) Icon-Labels ---------- */
  function iconLabels() {
    if (!cfg.iconLabels) return;
    [['search', '.header__icon--search'], ['account', '.header__icon--account'], ['cart', '.header__icon--cart']].forEach(function (p) {
      document.querySelectorAll(p[1]).forEach(function (el) {
        if (!cfg.labels[p[0]]) return;
        var host = el;
        if (el.tagName.indexOf('-') > -1) { /* Custom Element (z. B. <shopify-account>) mit Shadow DOM: Label in Wrapper daneben */
          if (el.parentElement && el.parentElement.classList.contains('lm-icon-wrap')) return;
          var w = document.createElement('span');
          w.className = 'lm-icon-wrap';
          el.parentNode.insertBefore(w, el);
          w.appendChild(el);
          host = w;
        }
        if (host.querySelector(':scope > .lm-icon-label')) return;
        var s = document.createElement('span');
        s.className = 'lm-icon-label';
        s.textContent = cfg.labels[p[0]];
        host.appendChild(s);
      });
    });
  }

  /* ---------- 2) Back to top ---------- */
  function backToTop() {
    if (!cfg.toTop) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lm-totop'; btn.setAttribute('aria-label', root.dataset.labelTop || 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5m0 0-6 6m6-6 6 6"/></svg>';
    document.body.appendChild(btn);
    var ticking = false;
    function check() { btn.classList.toggle('is-visible', window.scrollY > 700); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    check();
  }

  /* ---------- 3) Cart enhancements ---------- */
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function renderShipbar(container, cart) {
    if (!cfg.threshold || !container) return;
    var bar = container.querySelector('.lm-shipbar');
    if (cart.item_count === 0) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'lm-shipbar';
      bar.setAttribute('role', 'status');
      bar.innerHTML = '<div class="lm-shipbar__text"></div><div class="lm-shipbar__track"><div class="lm-shipbar__fill"></div></div>';
      var anchor = container.querySelector('.drawer__header') || container.querySelector('.cart__items') || container.firstElementChild;
      if (anchor && anchor.parentNode) anchor.insertAdjacentElement(anchor.classList.contains('drawer__header') ? 'afterend' : 'beforebegin', bar);
      else container.prepend(bar);
    }
    var total = cart.items_subtotal_price;
    var left = cfg.threshold - total;
    var done = left <= 0;
    bar.classList.toggle('lm-shipbar--done', done);
    bar.querySelector('.lm-shipbar__text').textContent = done ? cfg.msgDone : cfg.msgAway.replace('{amount}', money(left));
    bar.querySelector('.lm-shipbar__fill').style.width = Math.min(100, Math.round(total / cfg.threshold * 100)) + '%';
  }

  /* Kleines Icon-Set fuer JS-gerenderte Trust-Zeilen. Gleiche Sprache wie snippets/lm-icon.liquid:
     24er-Raster, currentColor, keine Emoji. */
  var TRUST_PATHS = {
    check: '<path d="m4.8 12.6 4.6 4.6L19.2 7.4"/>',
    shield: '<path d="M12 3 5 5.9v5.3c0 4.3 2.9 8.2 7 9.3 4.1-1.1 7-5 7-9.3V5.9L12 3Z"/><path d="m9 12 2.2 2.2L15.4 10"/>',
    lock: '<rect x="4.6" y="10.4" width="14.8" height="9.4" rx="2.2"/><path d="M8.2 10.4V7.8a3.8 3.8 0 0 1 7.6 0v2.6"/>',
    flag: '<path d="M4 21V4"/><path d="M4 5.2h15.4v8.6H4"/><path d="M4 8.1h15.4M4 11h15.4"/><path d="M4 5.2h6.8v5.8H4"/>'
  };
  function svgFor(label) {
    var t = String(label).toLowerCase(), k = 'check';
    if (t.indexOf('guarant') > -1 || t.indexOf('likeness') > -1) k = 'shield';
    else if (t.indexOf('secure') > -1 || t.indexOf('checkout') > -1) k = 'lock';
    else if (t.indexOf('usa') > -1) k = 'flag';
    return '<svg class="lm-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
      + 'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + TRUST_PATHS[k] + '</svg>';
  }

  /* Trust-Zeile unter dem Checkout-Button (Drawer + Cart-Seite) */
  function renderTrust(container) {
    if (!cfg.cartTrust || !container || container.querySelector('.lm-cart-trust')) return;
    var btn = container.querySelector('#CartDrawer-Checkout, #checkout, .cart__checkout-button');
    if (!btn) return;
    var p = document.createElement('p');
    p.className = 'lm-cart-trust';
    p.innerHTML = cfg.cartTrust.split('·').map(function (t) {
      return '<span>' + svgFor(t) + t.trim() + '</span>';
    }).join('');
    btn.insertAdjacentElement('afterend', p);
  }

  /* E-Mail-Capture-Dialog ("No photo handy?") */
  function capture() {
    var dlg = document.getElementById('lm-capture');
    if (!dlg) return;
    function open(detail) {
      var note = dlg.querySelector('[data-lm-capture-note]');
      if (note) note.value = 'upload-link requested on ' + location.pathname + (detail && detail.template_id ? ' · template ' + detail.template_id : '');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      var inp = dlg.querySelector('input[type=email]'); if (inp) setTimeout(function () { inp.focus(); }, 50);
    }
    document.addEventListener('lm:open-email-capture', function (e) { open(e.detail); });
    var close = dlg.querySelector('[data-lm-capture-close]');
    if (close) close.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    /* Nach dem Formular-Post kommt die Seite mit ?customer_posted=true zurück → Erfolgsansicht zeigen */
    if (location.search.indexOf('customer_posted=true') > -1 && dlg.querySelector('.lm-capture__form') && !dlg.querySelector('input[type=email]')) open();
  }

  function swapPreviews(cart) {
    if (!cfg.previews) return;
    cart.items.forEach(function (item, i) {
      var url = item.properties && item.properties._preview_url;
      if (!url) return;
      ['#CartDrawer-Item-' + (i + 1), '#CartItem-' + (i + 1)].forEach(function (sel) {
        var row = document.querySelector(sel);
        if (!row) return;
        var img = row.querySelector('.cart-item__image');
        if (!img) { /* Produkt ohne Bild (Dawn rendert dann kein <img>): eigenes anlegen */
          var cell = row.querySelector('.cart-item__media');
          if (!cell) return;
          img = document.createElement('img');
          img.className = 'cart-item__image';
          img.width = 150; img.height = 150; img.loading = 'lazy';
          cell.appendChild(img);
        }
        if (img.dataset.lmPreview === url) return;
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = url; img.dataset.lmPreview = url; img.classList.add('lm-cart-preview');
        img.alt = (item.product_title || '') + ' — your preview';
      });
    });
  }

  /* ---------- 4) Reveal beim Scrollen ----------
     Nur unterhalb des ersten Bildschirms und nie im Hero: was der Kunde sofort sieht, darf nicht erst erscheinen (LCP).
     Die Klasse kommt aus JS — ohne JS oder ohne IntersectionObserver ist nichts versteckt. */
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Drei Eintraege der alten Liste (.lm-ugc__card, .lm-compare, .lm-teaser__inner) trafen kein Element im
       Theme - die Vergleichstabelle, die Galerie und der Teaser blieben als einzige Abschnitte ohne
       Einblendung stehen. Selektoren, die nichts treffen, fallen nicht auf: sie sehen aus wie "keine
       Animation gewollt". Deshalb hier nur Klassen, die es wirklich gibt. */
    var sel = '.lm-section__head, .lm-grid > *, .lm-hiw__step, .lm-why__item, .lm-cats__item, .lm-faq__item, .lm-ugc__tile, .lm-cmp__row, .lm-cta__inner, .lm-teaser__pet, .lm-seo__copy, .lm-seo__media';
    var vh = window.innerHeight || 800;
    var items = [];
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.lm-hero')) return;
      if (el.classList.contains('lm-reveal')) return;
      /* Nicht gerenderte Elemente (inaktiver Tab, [hidden]) auslassen: sie loesen nie ein
         Intersection-Event aus und blieben sonst fuer immer unsichtbar. */
      if (!el.offsetParent) return;
      if (el.getBoundingClientRect().top < vh * 0.9) return;
      el.classList.add('lm-reveal');
      items.push(el);
    });
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--lm-reveal-delay', Math.min(i, 5) * 55 + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Der Zähler quittiert das Hinzufügen — sonst merkt der Kunde auf dem Handy nicht, dass etwas passiert ist. */
  var lastCount = null;
  function bumpCart(count) {
    if (lastCount !== null && count > lastCount) {
      document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
        b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
      });
    }
    lastCount = count;
  }

  var pending = null;
  function refresh() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var drawer = document.querySelector('cart-drawer .drawer__inner');
          var page = document.querySelector('cart-items');
          renderShipbar(drawer, cart);
          /* Dawn haelt den Cart-Drawer auf JEDER Seite im DOM. Die alte Bedingung (!drawer) hat den
             Balken deshalb auf der Warenkorbseite nie gezeichnet — er lag unsichtbar im Drawer. */
          if (page) renderShipbar(page.closest('.cart__contents') || page.parentElement, cart);
          renderTrust(document.querySelector('cart-drawer') || document);
          if (page) renderTrust(document.querySelector('.cart__footer') || document);
          swapPreviews(cart);
          bumpCart(cart.item_count);
          paintHeaderIcons(); /* Dawn rendert das Warenkorb-Icon nach jedem Update neu */
        })
        .catch(function () {});
    }, 120);
  }

  function watchCart() {
    var targets = ['cart-drawer', 'cart-items', 'cart-drawer-items'].map(function (t) { return document.querySelector(t); }).filter(Boolean);
    if (!targets.length) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.target.nodeType === 1 && m.target.closest && m.target.closest('.lm-shipbar')) continue; /* eigene Änderungen ignorieren (sonst Endlosschleife) */
        if (m.type === 'childList' && m.addedNodes.length) { refresh(); return; }
        if (m.type === 'attributes' && m.attributeName === 'class' && m.target.tagName === 'CART-DRAWER' && m.target.classList.contains('active')) { refresh(); return; }
      }
    });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); });
    document.addEventListener('cart:refresh', refresh);
    refresh();
  }

  function init() { paintHeaderIcons(); iconLabels(); backToTop(); watchCart(); capture(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { paintHeaderIcons(); iconLabels(); refresh(); reveal(); });
})();